// First Created - 16 May 2025
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userSessionMissionExecutesAdapter = createEntityAdapter({})

const initialState = userSessionMissionExecutesAdapter.getInitialState()

export const userSessionMissionExecutesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserSessionMissionExecutes: builder.query({
            query: () => ({
                url: '/userSessionMissionExecutes/getUserSessionMissionExecutes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserSessionMissionExecutes = responseData.map(userSessionMissionExecute => {
                    userSessionMissionExecute.id = userSessionMissionExecute._id
                    return userSessionMissionExecute
                })
                return userSessionMissionExecutesAdapter.setAll(initialState, loadedUserSessionMissionExecutes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserSessionMissionExecute', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserSessionMissionExecute', id}))
                    ]
                } else {
                    return [ { type: 'UserSessionMissionExecute', id: 'LIST'}]
                }
            },
        }),
        createNewUserSessionMissionExecute: builder.mutation({
            query: initialUserSessionMissionExecute => ({
                url: '/userSessionMissionExecutes/createNewUserSessionMissionExecute',
                method: 'POST',
                body: {...initialUserSessionMissionExecute,}
            }),
            invalidatesTags: [
                { type: 'UserSessionMissionExecute', id: "LIST" }
            ] 
        }),
        updateUserSessionMissionExecute: builder.mutation({
            query: initialUserSessionMissionExecute => ({
                url: '/userSessionMissionExecutes/updateUserSessionMissionExecute',
                method: 'PATCH',
                body: {...initialUserSessionMissionExecute,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserSessionMissionExecute', id: arg.id },
                { type: 'UserSessionMissionExecute', id: 'LIST' }
            ],
        }),
        deleteUserSessionMissionExecute: builder.mutation({
            query: ({id}) => ({
                url: '/userSessionMissionExecutes/deleteUserSessionMissionExecute',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserSessionMissionExecute', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserSessionMissionExecutesQuery,
    useCreateNewUserSessionMissionExecuteMutation,
    useUpdateUserSessionMissionExecuteMutation,
    useDeleteUserSessionMissionExecuteMutation,
} = userSessionMissionExecutesApiSlice

// returns the query result object
export const selectUserSessionMissionExecuteResult = userSessionMissionExecutesApiSlice.endpoints.getUserSessionMissionExecutes.select()

// create memoized selector
const selectUserSessionMissionExecutesData = createSelector(
    selectUserSessionMissionExecuteResult,
    userSessionMissionExecuteResult => userSessionMissionExecuteResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserSessionMissionExecutes,
    selectById: selectUserSessionMissionExecuteById,
    selectIds: selectUserSessionMissionExecuteIds,
} = userSessionMissionExecutesAdapter.getSelectors(state => selectUserSessionMissionExecutesData(state) ?? initialState)